export var ParticipationClassTeamMode;
(function (ParticipationClassTeamMode) {
    ParticipationClassTeamMode[ParticipationClassTeamMode["Required"] = 2] = "Required";
    ParticipationClassTeamMode[ParticipationClassTeamMode["Optional"] = 1] = "Optional";
    ParticipationClassTeamMode[ParticipationClassTeamMode["Disabled"] = 0] = "Disabled";
})(ParticipationClassTeamMode || (ParticipationClassTeamMode = {}));
export function getParticipationClassTeamModeLabel(teamMode) {
    switch (teamMode) {
        case ParticipationClassTeamMode.Required:
            return 'required';
        case ParticipationClassTeamMode.Optional:
            return 'optional';
    }
    return 'disabled';
}
//# sourceMappingURL=ParticipationClassTeamMode.js.map